import { createI18n } from 'vue-i18n/index'
import en from "../lang/en.json";
import de from "../lang/de.json";

export default createI18n({
    locale: localStorage.getItem("lang") || "de",
    messages: {
        en: en,
        de: de,
    },
    silentTranslationWarn: true,
    fallbackLocale: 'de',
})
